/** A schema.org `AggregateOffer` over per-request USD amounts, or undefined when
 *  there is nothing to price. Shared by the homepage and the platform pages so
 *  both publish the range in the same seven keys. */
export const aggregateOffer = (usd: number[]) => {
  if (usd.length === 0) return undefined;
  return {
    '@type': 'AggregateOffer',
    priceCurrency: 'USD',
    lowPrice: Math.min(...usd),
    highPrice: Math.max(...usd),
    offerCount: usd.length,
    unitText: 'request',
    availability: 'https://schema.org/InStock',
  };
};
